import {  Auth } from "aws-amplify";
import classNames from "classnames";
import { preInterestColor } from "components/Leasing/constrant/leasing.ct";
import { prePrincipleColor } from "components/Leasing/constrant/leasing.ct";
import { preOverflow } from "components/Leasing/constrant/leasing.ct";
import { preLateColor } from "components/Leasing/constrant/leasing.ct";
import { ReversePaymentContext } from "components/Leasing/context/leasing.ctx.reversePayment";
import { getFilterInstallments } from "components/Leasing/utils/leasing.u";
import { format } from "date-fns";
import moment from "moment";
import numeral from "numeral";
import { useContext } from "react";
import { getCurrentLocalDateTime } from "utils/getLocalDateTime";
import { feeRemarkColor } from "../constrant/leasing.ct";
import { getFeeTypeText } from "../utils/leasing.u";
import API from "../api/api.main"

const FootageEvidencesAddFee = ({
  item,
  index,
  loan,
  setInstallments,
  setLoan,
  setLoading,
  setDate,
}) => {
  const {
    openReverse,
    currentEvidenceIndex,
    setCurrentEvidenceIndex,
    setEvidence,
  } = useContext(ReversePaymentContext);

  return (
    <div
      className={classNames(
        "relative bg-white  overflow-hidden p-2 w-60 flex-shrink-0"
      )}
    >
      <div className="flex flex-row w-full">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 24 24"
          strokeWidth={1.5}
          stroke="currentColor"
          className="w-12 h-12 mr-1 text-red-500"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            d="M12 6v12m-3-2.818l.879.659c1.171.879 3.07.879 4.242 0 1.172-.879 1.172-2.303 0-3.182C13.536 12.219 12.768 12 12 12c-.725 0-1.45-.22-2.003-.659-1.106-.879-1.106-2.303 0-3.182s2.9-.879 4.006 0l.415.33M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
          />
        </svg>

        <div className="text-xs ml-2 w-full">
          <div className="flex w-full justify-between text-gray-700">
            {/* <div className="tooltiptext">{item.installment_relate}</div> */}
            <div className=" w-32 h-4 overflow-auto text-red-500 ">
              {" "}
              <div>
                {getFeeTypeText(item?.fee_type)} {item?.installment_relate}
              </div>
            </div>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className="h-5 w-5 text-green-500"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"
              />
            </svg>
          </div>
          <div className="text-xs font-bold text-gray-700">
            {numeral(item.fee_amount).format("0,000.00")}
          </div>

          <div className="text-gray-500 font-thin">
            {format(new Date(item.paidDate), "dd-MM-yyyy HH:mm")}
          </div>
        </div>
      </div>
      <div className="flex flex-col justify-end">
        <div className="grid grid-cols-2 text-xs mt-2">
          <div className={feeRemarkColor}>(หมายเหตุ): {item?.fee_remark}</div>
        </div>
      </div>
    </div>
  );
};

export default FootageEvidencesAddFee;
